import { React, useEffect, useState, Fragment } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
// import EditPopupForm from "./EditPopupForm";
import * as tagService from "../api/api";
import MyCard from '../../../shared/components/myCard'
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from "react-toastify";

import EditPopupForm from "./editPopupForm";
import * as languageService from "../../Language/api/api"

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Editor, EditorTools } from "@progress/kendo-react-editor";

// Material UI
import { Box, Button,  Select, MenuItem,TextField } from '@mui/material';
const EditCommandCell = (props) => {
    return (
        <td>
            <button 
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                    onClick={() =>{
                         props.enterEdit(props.dataItem)
                    }
                }
            >
                Güncelle
            </button>
        </td>
    );
};

const Tags =()=>{

    const ShowLanguagesText = (props) => {
        console.log(props);
        return (
        
            <td>
            {props.dataItem.languages.map((itm) => (
                <span key={itm.id}>
                    {itm.name},
                </span>
            ))}            
        </td>
    )};

    const MyEditCommandCell = (props) => (
        <EditCommandCell {...props} enterEdit={enterEdit} />
    );
    const enterEdit = (item) => {
        setOpenForm(true);
        setEditItem(item);
    };
    const handleUserUpdateSubmit = (id,name,surname,email,languageId) => {
updateTag(id,name,surname,email,languageId);
        setOpenForm(false);
    };
    const handleCancelEdit = () => {
        setOpenForm(false);
    };
    const [tagList, setTagList] = useState([]);
    const [editItem, setEditItem] = useState({});

    const [openForm, setOpenForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    const defaultInputValues = {
        name: '',        
        surname:'',
        email:'',
        password:'',
        languageId:[],
        photo:''
        
    };

    const validationSchema = Yup.object().shape({
        title: Yup.string().required('Boş geçilemez'),
        sourceName: Yup.string().required('Boş geçilemez'),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        setValue,
        getValues,
    } = useForm({ defaultValues: defaultInputValues, resolver: yupResolver(validationSchema) });

    
    const [languageList, setLanguageList] = useState([]);
    const [languageId, setLanguageId] = useState([]);

    function handleAddTag() {
     
         addTag(getValues("title"),getValues("sourceName"));
     }
     function addTag(title,sourceName) {
        const template = {                        
            "title": title,
            "sourceName":sourceName,
        };
        tagService.create(template).then((res) => {
            const { isSuccess,message, data: userResData } = res;
            if (isSuccess) {                
                toast.success("User eklendi.");
                getTagList();
                setValue('title','');
                setValue('sourceName','');
                setLanguageId([]);
            } else {
                toast.error("HATA:"+JSON.stringify(message,2,null));
            }
        });
    }

    function updateTag(id,title,sourceName) {
        const template = {   
            "id":id,
            "title": title,
            "sourceName":sourceName,
        };
        tagService.update(template).then((res) => {
            const { isSuccess,message, data: datax } = res;
            if (isSuccess) {                
                toast.success("Tag güncellendi.");
                getTagList();
                setValue('title','');
                setValue('sourceName','');
            } else {
                toast.error("HATA:"+JSON.stringify(message,2,null));
            }
        });
    }

    useEffect(() => {
        getTagList();
     }, []);
 
     function getTagList() {
        setIsLoading(true);
        const pagerInputModel = {
            "pageNumber":1,
            "pageSize": 1000,            
        };
        tagService.list(pagerInputModel).then((res) => {
            const { isSuccess,message, data: datax } = res;
            if (isSuccess) {
                setTagList(datax);
              
            } else {
                toast.error(message);
            }
            setIsLoading(false);
        });
    }
return(
<>

<MyCard header="TAG Ekle">
           <Box component="div" sx={{ pt: 1 ,width:250 }}>
                    <TextField fullWidth
                        required
                        id="outlined-required"
                        label="Başlık"
                        error={errors.title ? true : false}
                        helperText={errors.title?.message}
                        {...register('title')}
                        size="small"
                       
                    />
                </Box>
                <Box component="div" sx={{ pt: 1 ,width:250 }}>
                    <TextField fullWidth
                        required
                        id="outlined-required"
                        label="Kaynak"
                        
                        error={errors.sourceName ? true : false}
                        helperText={errors.sourceName?.sourceName}

                        {...register('sourceName')}

                        size="small"
                       
                    />
                </Box>
           
             
      

                <Box component="div" sx={{ pt: 2 ,width:250 }}>
                    <Button fullWidth onClick={handleSubmit(handleAddTag)} variant="outlined">Ekle</Button>
                </Box>
                </MyCard>





                


<MyCard header="Tag Listesi">


    <Grid
        style={{
            height: "400px",
            width: "100%"
        }}
        data={tagList}
    >
        <Column field="id" title="ID" width="40px" />
        <Column field="title" title="Başlık" width="300px" />        
        <Column field="sourceName" title="Kaynak" width="300px" />        
        <Column cell={MyEditCommandCell} />
    </Grid>
    {openForm && (
        <EditPopupForm key={editItem.id}
        openForm={openForm}
            cancelEdit={handleCancelEdit}
            onSubmit={handleUserUpdateSubmit}
            item={editItem}
            languageList={languageList}
        />
    )}
</MyCard>



</>
);
}

export default  Tags;